import { MutationTree } from 'vuex';
import { IDashboardActivity } from '../types/dashboard-activity';
import { EDashboardMutation } from './dashboard.constants';
import { IDashboardState } from './dashboard.types';

export const mutations: MutationTree<IDashboardState> = {
  [EDashboardMutation.SetActivities](state: IDashboardState, activity: IDashboardActivity[]) {
    state.activities = activity;
  },
};
